export enum HosRuleResultsActionTypes {
    SET_HOS_RULE_RESULTS = "SET_HOS_RULE_RESULTS",
    CLEAR_HOS_RULE_RESULTS = "CLEAR_HOS_RULE_RESULTS"
}